module.exports = __webpack_public_path__ + "img/recreate-smash-cel.26d1898e.png";